import { ActiveSettlementBatchModel } from '../../../../api/Argentia/endpoints/settlementBatchs/model/settlementBatchs'
import { EnumEstadoLoteLiquidacion } from '../../../../api/oData/enums/enumEstadoLoteLiquidacion'
import { enumEnumToValueString } from '../../../../helpers'
import { formatDate } from '../../../../helpers/formatDateHelper'
import { generateIconsFromConfiguration } from '../../../../helpers/dataTableActionIconHelper'
import i18n from '../../../../i18n'
import { ActionIcons, DataTableActionConfiguration } from '../../../../model'

export type BatchTableModel = ActiveSettlementBatchModel & {
  executionDateLabel: string
  statusLabel: string
  canViewProgress: boolean
  actions?: JSX.Element
}

const getFocusedBatchAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.FOCUSED_ITEM,
    tooltip: i18n.t('invoiceCyclesProcessingPage:batches.tooltips.focusedBatch')
  }
}

/**
 * Lotes ordenados de más antiguo a más nuevo (fecha de ejecución, con el id como desempate)
 * y con el icono de seguimiento en el lote en foco
 */
export const mapBatchesToTableModel = (
  batches: ActiveSettlementBatchModel[],
  focusedBatchId?: number
): BatchTableModel[] => {
  return [...batches]
    .sort(
      (a, b) =>
        new Date(a.executionDate).getTime() - new Date(b.executionDate).getTime() || a.id - b.id
    )
    .map(batch => completeBatchTableItemActions(batch, focusedBatchId))
}

const completeBatchTableItemActions = (
  batch: ActiveSettlementBatchModel,
  focusedBatchId?: number
): BatchTableModel => {
  const isFocused = batch.id === focusedBatchId
  return {
    ...batch,
    executionDateLabel: formatDate(batch.executionDate, 'DD/MM/YYYY - HH:mm:ss'),
    statusLabel: enumEnumToValueString(EnumEstadoLoteLiquidacion, batch.status),
    // El lote en foco ya es el que se está viendo: no se ofrece "Ver progreso"
    canViewProgress: !isFocused && batch.status === EnumEstadoLoteLiquidacion.EnCurso,
    actions: isFocused
      ? generateIconsFromConfiguration(
          batch,
          [getFocusedBatchAction()],
          new Map<ActionIcons, Function>([])
        )
      : undefined
  }
}
